<template>
	<router-link
		v-if="podcast"
		:to="`/podcasts/${podcast.id}/episode/${episode.linkid}`"
		class="hover:bg-light-blue p-2 -m-2 rounded-lg transition cursor-pointer flex-1 flex flex-row items-center gap-3"
		:class="{ '!flex-col' : 'vertical' == orientation }"
	>
		<img
			:src="podcast.icon"
			:alt="podcast.name"
			class="size-18 md:size-24 rounded-md"
			:class="{ '!w-full !h-auto' : 'vertical' == orientation }"
		/>
		<div class="flex-1 flex flex-col gap-1">
			<h2 class="text-base font-bold leading-tight line-clamp-2">{{ episode.name }}</h2>
			<div v-if="play" class="flex flex-col md:flex-row md:gap-3">
				<span class="text-sm">{{ podcast.name }}</span>
				<div class="flex flex-row gap-3">
					<span class="text-sm">{{ formattedDuration(episode.seconds) }}</span>
					<span class="text-sm">{{ format(new Date(episode.published), 'dd MMM') }}</span>
				</div>
			</div>
		</div>
	</router-link>
	<div v-if="play">
		<PlayButton :episode="episode" />
	</div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { usePodcastStore } from '../stores/podcastStore'
import PlayButton from '@/components/PlayButton.vue'
import { format } from 'date-fns'

const store = usePodcastStore()

const props = defineProps({
	episode: {
		type: Object,
		required: true
	},
	play: {
		type: Boolean,
		required: false,
		default: false
	},
	orientation: {
		type: String,
		required: false,
		default: 'horizontal'
	}
})

const podcast = computed(() => {
	return store.getPodcastByEpisodeLinkid(props.episode.linkid)
})

const formattedDuration = computed(() => {
	return (seconds) => {
		if (!seconds) return '0 min'
		
		const hours = Math.floor(seconds / 3600)
		const minutes = Math.floor((seconds % 3600) / 60)

		const parts = []
		if (hours > 0) parts.push(`${hours} tim`)
		if (minutes > 0) parts.push(`${minutes} min`)

		return parts.join(' ') || '0 min'
	}
})

</script>
